var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7722 0.230395L19.7936 0.251813C19.8614 0.32759 19.9081 0.42018 19.9284 0.520198C19.9509 0.630468 19.9405 0.744907 19.8984 0.8493L19.8984 0.849427L12.4873 19.3765C12.4263 19.529 12.3243 19.6617 12.1927 19.76C12.0612 19.8583 11.905 19.9184 11.7415 19.9336C11.5779 19.9489 11.4133 19.9187 11.2658 19.8465C11.1183 19.7742 10.9936 19.6627 10.9054 19.5241L6.85792 13.1625L6.85046 13.1508L6.83874 13.1433L0.477088 9.09579L0.477017 9.09575C0.338133 9.00765 0.226288 8.88289 0.153822 8.73525C0.0813564 8.5876 0.0510874 8.42281 0.0663552 8.25905C0.081623 8.09529 0.141834 7.93893 0.240344 7.80723C0.338854 7.67552 0.471834 7.57359 0.62461 7.51269L0.62467 7.51266L19.1518 0.104103L19.1519 0.104049C19.2563 0.0620239 19.3708 0.0515949 19.481 0.0740572C19.5913 0.0965196 19.6925 0.150883 19.7722 0.230395ZM8.03205 12.78L7.9966 12.8154L8.02352 12.8577L11.5399 18.3826L11.6054 18.4855L11.6507 18.3723L17.6787 3.30297L17.5764 3.23556L8.03205 12.78ZM16.7202 2.31681H16.7082L16.697 2.32128L1.6277 8.34926L1.51445 8.39456L1.61737 8.46002L7.14354 11.9752L7.18583 12.0021L7.22127 11.9666L16.7657 2.42351L16.8724 2.31681H16.7215H16.7202Z",
    fill: "#1F2F3D",
    stroke: "#1F2F3D",
    strokeWidth: 0.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublish);
export default __webpack_public_path__ + "static/media/publish.fa03c0ed8281b9412d53eb65352246d4.svg";
export { ForwardRef as ReactComponent };